/**
 * Helpers para evitar el bug de jsPDF v4 + Helvetica core que causa que el texto
 * se vea con espacios gigantescos entre cada letra cuando el contenido incluye
 * caracteres fuera de Latin-1 (curly quotes, en/em dashes, ellipsis, etc.).
 *
 * Uso: justo despues de `new jsPDF()` llamar a `patchJsPdfText(doc)`.
 * Cada doc.text y doc.splitTextToSize sanitizara automaticamente sus argumentos.
 */

const _PDF_REPLACE = {
  "\u2010": "-", "\u2011": "-", "\u2012": "-", "\u2013": "-", "\u2014": "-", "\u2015": "-",
  "\u2018": "'", "\u2019": "'", "\u201A": "'", "\u201B": "'",
  "\u201C": '"', "\u201D": '"', "\u201E": '"', "\u201F": '"',
  "\u2022": "*", "\u2023": ">", "\u2026": "...", "\u2032": "'", "\u2033": '"',
  "\u00A0": " ", "\u202F": " ", "\u2007": " ", "\u2008": " ", "\u2009": " ", "\u200A": " ",
  "\u200B": "", "\u200C": "", "\u200D": "", "\uFEFF": "",
  "\u2190": "<-", "\u2192": "->", "\u2194": "<->",
  "\u00AB": '"', "\u00BB": '"',
  "\u2061": "", "\u2062": "", "\u2063": "", "\u2064": "",
};

const _PDF_RE = /[\u2010-\u2015\u2018-\u201F\u2022\u2023\u2026\u2032\u2033\u00A0\u202F\u2007-\u200D\uFEFF\u2190\u2192\u2194\u00AB\u00BB\u2061-\u2064]/g;

export const sanitizePDFText = (s) => {
  if (s == null) return "";
  return String(s).replace(_PDF_RE, (m) => _PDF_REPLACE[m] ?? "");
};

export const patchJsPdfText = (doc) => {
  if (!doc || doc.__qaPatched) return doc;
  const _origText = doc.text.bind(doc);
  doc.text = function (text, ...rest) {
    if (typeof text === "string") {
      text = sanitizePDFText(text);
    } else if (Array.isArray(text)) {
      text = text.map((t) => (typeof t === "string" ? sanitizePDFText(t) : t));
    }
    return _origText(text, ...rest);
  };
  const _origSplit = doc.splitTextToSize.bind(doc);
  doc.splitTextToSize = function (text, ...rest) {
    if (typeof text === "string") text = sanitizePDFText(text);
    return _origSplit(text, ...rest);
  };
  doc.__qaPatched = true;
  return doc;
};
